export interface PricingTab {
   label: string;
   id: 'quotes' | 'list-prices';
   badge?: string;
   active?: boolean;
}

export const buildTabs = (
   hasSmallLot: boolean,
   quotesBadge: string,
   listPricesBadge: string | undefined,
   translate: (key: string) => string
): PricingTab[] => {
   if (!hasSmallLot) {
      return [{ label: translate('dynamic-product-block.quotes'), id: 'quotes', badge: quotesBadge, active: true }];
   }

   return [
      { label: translate('dynamic-product-block.quotes'), id: 'quotes', badge: quotesBadge },
      { label: translate('dynamic-product-block.list-prices'), id: 'list-prices', badge: listPricesBadge }
   ];
};
